import { ReactNode } from 'react'
import styled from 'styled-components'

type MenuGridProps = {
  children: ReactNode[] | ReactNode
  className?: string
  testId?: string
}

const MenuGrid = ({ children, className, testId }: MenuGridProps) => {
  const arrayOnlyChildren: ReactNode[] = Array.isArray(children)
    ? children
    : [children]

  const leftChildren = arrayOnlyChildren.filter(
    (element, index) => index % 2 === 0,
  )
  const rightChildren = arrayOnlyChildren.filter(
    (element, index) => index % 2 !== 0,
  )

  return (
    <Wrapper className={className} data-testid={testId}>
      <LeftColumn>{leftChildren}</LeftColumn>
      {rightChildren.length > 0 && <RightColumn>{rightChildren}</RightColumn>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  > * {
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: fit-content;
  }
  ${({ theme }) => theme.mediaQueries.tabletDown} {
    display: flex;
    flex-direction: column;
  }
`

const LeftColumn = styled.div``

const RightColumn = styled.div``

export default MenuGrid
